import * as React from 'react';
import {SpinLoader} from 'app/components/spin-loader';
import { useActionCreators, useSelectors } from 'app/area/case/edit/hooks';
import { useEffect } from 'react';
import { WithRouterProps } from 'app/components/enhancers/with-router';

/**
 * Runs the action creator to create a new entity then redirects to the draft
 *
 */
export const Editor = (api: any = undefined): React.ComponentType<React.PropsWithChildren<WithRouterProps>> => (
  { params, router }: WithRouterProps
) => {
  const {
    editCase
  } = useActionCreators(api);

  const {
    caseNumber,
    caseContextId,
    entityPath
  } = useSelectors(params, router);

  useEffect(() => {
    editCase( caseNumber, caseContextId, entityPath );
  }, [caseNumber, caseContextId, entityPath]);

  return <SpinLoader/>;
};
